module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAAXNSR0IArs4c6QAAAUFJREFUKFONkjlLA1EUhb+XGDGGAWMUJC5prAwI/oMEFzAgAcEgBuuUAQsFC5dGGy3sVBBsRGIRsBAhIIIiooWVCIoIAbtg4ULUzExG3gyKg5nBWz7Od965lyMSq8YhMECN+VRhKUW+XCQdjwtNSsTwinEsBDEnYG0SmgPkF3KMb2aE+i8gGJDW7J89knIF9Cr0R6GpUerh6Y2tH0DVwSPA67GHqxqg6VBfZ74XTMCA2HQCLh/g5NYO9IQhE4fMNjT4fgFzSTi/h6MbkK4yghDQ2wHZIUhvOACFa5gdgVYFZvYgGnYBTu+gLwKdQSi9guKH3AVkBx1+iISgosHULnyosDhqwXL+RJpPQlcIsjtQrlgiebXlMWhRYGId/N9LC4h1t0HpBZ7f7VfyeSHaDldF08A6q1M1atSlINzKVwM4+AKKIYX36S4csgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/word-1.png
// module id = wwYX
// module chunks = 1